export var INTEGRATION_TYPES;
(function (INTEGRATION_TYPES) {
  INTEGRATION_TYPES["PAYMENT_PROCESSOR"] = "PAYMENT_PROCESSOR";
  INTEGRATION_TYPES["NETWORK_MONITOR"] = "NETWORK_MONITOR";
  INTEGRATION_TYPES["QUALITY_OF_SERVICE"] = "QUALITY_OF_SERVICE";
})(INTEGRATION_TYPES || (INTEGRATION_TYPES = {}));